<template>
  <div class="comment">
    <div
      v-if="versionData"
      v-ie-placeholder
      class="comment-content"
    >
      <input
        ref="minput"
        v-model="milestone_desc"
        class="comment-input"
        maxlength="10"
        :placeholder="`${$t('添加标记，限10个字符')}`"
        @keyup="handler"
      >
      <span
        v-if="milestone_desc.length"
        class="clearAll"
        @click="()=>{this.milestone_desc = ''}"
      >x</span>
      <div
        class="count"
        :class="warn?'warn':''"
      >
        {{ textCount }}/10
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['versionData'],
  data() {
    return {
      textCount: 0, // 字符数量
      warn: false, // 提示
      milestone_desc: '', // 版本标记
    }
  },
  watch: {
    versionData: {
      handler(n, o) {
        this.milestone_desc = this.versionData.milestone_desc || ''
        this.textCount = (this.milestone_desc && this.milestone_desc.length) || 0
      },
      deep: true,
    },
  },
  mounted() {
    this.milestone_desc = this.versionData.milestone_desc || ''
    this.textCount = (this.milestone_desc && this.milestone_desc.length) || 0
  },
  methods: {
    /**
             * 检验字符的方法
             */
    handler() {
      this.textCount = this.$refs.minput.value.length || 0
      if (this.textCount == 10) {
        this.warn = true
      } else {
        this.warn = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.comment{
  position: relative;
  .comment-content{
    padding:24px;
  }
  .comment-input {
    width: 100%;
    font-size: 12px;
    padding: 8px 12px;
    border-top: none;
    border-left: none;
    border-right: none;
    resize: none;
    box-sizing: border-box;
    overflow: hidden;
    height: 32px;
    outline: none;
    border: 1px solid #C1C7CD;
    border-radius: 2px;
  }
  .warn{
    color: red!important;
  }
  .count {
    font-size: 12px;
    position: absolute;
    color: #929ca9;
    right: 26px;
    cursor: auto;
    #length {
      display: inline-block;
      width: 30px;
      text-align: right;
    }
  }
  .clearAll {
    position: absolute;
    bottom: 33px;
    width: 14px;
    height: 14px;
    background: #c1c7cd;
    line-height: 11px;
    text-align: center;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
    right: 30px;
    color: #fff;
  }
}
</style>
